import React from 'react';

const LoadingSpinner = () => (
  <div className="loading">
    <div className="spinner"></div>
    <p>Generating ethical medical content...</p>
  </div>
);

export default LoadingSpinner;
